<template>
  <div>
    <!-- Show loading card -->
    <v-card v-if="Loading" class="loading height1 px-4 py-3 ">
      <p class="t-a">
        <span class="font-weight-bold"> Aguarde </span>
        <span class="text-caption t-a">
          {{ title }} está sendo gerado</span
        >
      </p>
    </v-card>

    <!-- default card -->
    <div v-else>
      <!-- main display -->
      <v-card
        dark
        :class="
          ` px-4 py-3 ${
            clickIcon ? 'card-renomear height2' : 'card height1'
          }`
        "
        @click="handleClick"
        elevation="0"
      >
        <template v-if="!clickIcon">
          <div class="position-relative">
            <p class="float-right mr-10">
              <span>{{ description }}</span
              ><slot class="w-100"></slot>
            </p>

            <v-icon @click.stop="openEdit" class="edit-icon">
              mdi-square-edit-outline
            </v-icon>

            <p class="text-start pe-5">
              <span class="font-weight-bold ">{{ title }}</span>
              <span class="mt-n4 ml-4">{{ date }}</span>
            </p>
          </div>
        </template>

        <template v-if="clickIcon && saved">
          <div class="mt-1">
            <v-icon @click.stop="clickIcon = false" class="ma-2">
              mdi-arrow-left
            </v-icon>
            <v-btn small outlined @click.stop="duplicarPlan">
              duplicar
            </v-btn>
            <v-icon @click.stop="deletePlan" class="ma-2">
              mdi-delete
            </v-icon>
          </div>
        </template>

        <template v-else-if="clickIcon">
          <div class="d-flex align-center" style="width: 100%;">
            <!-- Campo de texto ocupa a maior parte -->
            <v-text-field
              dense
              v-model="titleCopy"
              label="Renomear"
              maxlength="26"
              :rules="[rules.required, rules.counter]"
              counter
              outlined
              class="flex-grow-1 mr-4"
            ></v-text-field>

            <!-- Ícones ao lado -->
            <div class="d-flex align-center mt-n6">
              <v-icon @click.stop="clickIcon = false" class="ma-2"
                >mdi-arrow-left</v-icon
              >
              <v-icon @click.stop="save" class="ma-2"
                >mdi-checkbox-marked-circle</v-icon
              >
              <v-icon @click.stop="deletePlan" class="ma-2"
                >mdi-delete</v-icon
              >
            </div>
          </div>
        </template>
      </v-card>

      <!-- Edit display
      <v-card
        
        dark
        class="card-renomear height2 px-4 py-2"
      >
        
      </v-card>

      <v-card  dark class="card-renomear pa-4">
       
      </v-card> -->
    </div>
  </div>
</template>

<script>
// import HelpIcon from "./HelpIcon.vue";

export default {
  name: "PlanCardList",
  // comments: {
  //   HelpIcon
  // },
  props: {
    id: String,
    title: String,
    date: String,
    description: String,
    AddNew: Boolean,
    Loading: Boolean,
    waiting: Number,
    saved: Boolean
  },
  data() {
    return {
      clickIcon: false,
      titleCopy: "",
      rules: {
        required: value => !!value || "Digite algo.",
        counter: value => value.length <= 26 || "Max 26 caracteres"
      }
    };
  },
  methods: {
    handleClick() {
      this.$emit("open");
    },
    openEdit() {
      this.clickIcon = true;
      this.titleCopy = this.$props.title;
    },
    save() {
      if (this.titleCopy.length > 0) {
        this.$emit("update:title1", this.titleCopy);
        this.clickIcon = false;
      }
    },
    deletePlan() {
      this.$emit("delete");
      this.clickIcon = false;
    },
    duplicarPlan() {
      this.$emit("duplicar");
      this.clickIcon = false;
    }
  }
};
</script>

<style scoped>
.card,
.loading,
.card-renomear,
.addNew {
  position: relative;
  min-width: 800px;
  max-width: 900px;
}

.height1 {
  height: 50px;
}
.height2 {
  height: 80px;
}

.clickable-area {
  margin: -8% 0 0 -8%;
  height: 126%;
  width: 116%;
  clip-path: polygon(0 0, 72% 0, 100% 33%, 100% 100%, 0 100%);
}

.card {
  background-color: #eee;
  color: #424242;
  text-align: center;
  border-radius: 10px;
  cursor: pointer;
}

.card:hover {
  background-color: var(--v-primary-base);
  color: white;
}

.card-renomear {
  background-color: var(--v-primary-base);
  text-align: center;
  border-radius: 10px;
  cursor: pointer;
}

.edit-icon {
  position: absolute;
  color: #424242;
  top: 0;
  right: 0;
}

.edit-icon:hover {
  color: white;
}

p {
  font-size: 1rem;
}

.loading {
  border-radius: 10px;
  text-align: center;
  background: linear-gradient(
    45deg,
    #0088ff,
    #2f7dc2,
    #3b3dc9,
    #0088ff
  );
  background-size: 600% 100%;
  animation: gradient 4s linear infinite;
  animation-direction: alternate;
}

.wrapper {
  width: 100%;
  height: 100px;
}

@keyframes gradient {
  0% {
    background-position: 0%;
  }

  100% {
    background-position: 100%;
  }
}

.addNew {
  background-color: var(--v-primary-base);
  border-radius: 10px;
  cursor: pointer;
  text-align: center;
}

.saci {
  width: 40px;
  margin-top: -10px;
}

.t-a {
  color: white;
}

.plus {
  font-size: 5rem;
  line-height: 1.2;
  margin: 0;
}

.position-relative {
  position: relative;
}

.w-100 {
  display: table;
  width: 90%;
}
</style>
